import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import _ from 'lodash';
import { Input, Header, Message, Button, Form, Checkbox, Modal, Divider } from 'semantic-ui-react';
import { withFormik } from 'formik';
import gql from 'graphql-tag';
// import { graphql } from 'react-apollo';
// import compose from 'lodash/flowRight';
import { AuthClient, EnjoyIcon, log } from '@emyw/core-lib';
import { normalizeErrors } from '../utils';
import ButtonLink from '../ButtonLink';
import '../primitives.css';
const {
  REACT_APP_ENJOY_SITE_ROOT_URL
} = process.env;
const {
  REACT_APP_TOKEN_NAME,
  REACT_APP_REFRESH_TOKEN_NAME
} = process.env;
const registerMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation (\n        $firstName: String!, $lastName: String!, $email: String!, $password: String!,\n        $promotionalOptIn: Boolean, $origin: String!, $preRegistrationMode: Boolean\n    ) {\n        register(\n            firstName: $firstName,\n            lastName: $lastName,\n            email: $email,\n            password: $password,\n            promotionalOptIn: $promotionalOptIn,\n            origin: $origin,\n            preRegistrationMode: $preRegistrationMode)\n        {\n            ok\n            token\n            refreshToken\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"])));
const socialLoginMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation($network: String!, $accessToken: String!, $rememberMe: Boolean!, $jsonProfile: String!, $preRegistrationMode: Boolean) {\n        socialLogin(\n            network: $network,\n            accessToken: $accessToken,\n            rememberMe: $rememberMe,\n            jsonProfile: $jsonProfile,\n            preRegistrationMode: $preRegistrationMode\n        ) {\n            ok\n            token\n            refreshToken\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const Wrapper = props => props.children;
const NewAccountLogic = withFormik({
  validateOnBlur: false,
  validateOnChange: false,
  // Transform outer props into form values
  mapPropsToValues: props => {
    const {
      firstName,
      lastName,
      email,
      promotionalOptIn
    } = props.user || '' || (props.socialNetworkUser || '').profile || '';
    return {
      firstName: firstName || '',
      lastName: lastName || '',
      email: email || '',
      password: '',
      passwordConfirm: '',
      promotionalOptIn: promotionalOptIn || false
    };
  },
  // Add a custom validation function (this can be async too!)
  validate: (values, props) => {
    // , props
    const errors = {};
    // First Name
    if (!values.firstName) {
      errors.firstName = 'First name required';
    } else if (values.firstName.length < 2) {
      errors.firstName = 'First name must be at least 2 characters';
    }
    // Last Name
    if (!values.lastName) {
      errors.lastName = 'Last name required';
    } else if (values.lastName.length < 2) {
      errors.lastName = 'Last name must be at least 2 characters';
    }
    // Email
    if (!values.email) {
      errors.email = 'Email required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    // If there was no social network used for authentication, then require a password
    if (!props.socialNetworkUser) {
      // Password
      if (!values.password) {
        errors.password = 'Password required';
      } else if (values.password.length < 5) {
        errors.password = 'Password must be at least 5 characters';
      }
      // Password Confirm
      if (values.passwordConfirm !== values.password) {
        errors.passwordConfirm = 'Passwords don\'t match';
      }
    }
    // Changed check box to promotional email opt-in, and put terms note at the bottom saying the user is agreeing by continuing, so no need to
    // make sure box is checked before continuing
    // Terms of Use
    // if (!values.termsOfUse) {
    //     errors.termsOfUse = 'Please review and accept the Terms of Use';
    // }
    return errors;
  },
  // Submission handler
  handleSubmit: async (values, _ref) => {
    let {
      props: {
        onComplete,
        socialNetworkUser,
        preRegistration,
        onUserAlreadyExists
      },
      setSubmitting,
      setErrors,
      setStatus
    } = _ref;
    try {
      let res = null;
      if (socialNetworkUser) {
        const {
          profile
        } = socialNetworkUser;
        // ensure that we get the data they specified here
        profile.email = values.email;
        profile.firstName = values.firstName;
        profile.lastName = values.lastName;
        const jsonProfile = JSON.stringify(profile);
        const {
          accessToken
        } = socialNetworkUser.token;
        const response = await AuthClient.mutate({
          mutation: socialLoginMutation,
          variables: {
            network: socialNetworkUser.provider,
            accessToken,
            rememberMe: false,
            jsonProfile,
            preRegistrationMode: preRegistration
          }
        });
        res = response.data.socialLogin;
      } else {
        const response = await AuthClient.mutate({
          mutation: registerMutation,
          variables: {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            promotionalOptIn: values.promotionalOptIn,
            origin: REACT_APP_ENJOY_SITE_ROOT_URL,
            preRegistrationMode: preRegistration
          }
        });
        res = response.data.register;
      }
      const {
        ok,
        token,
        refreshToken,
        errors
      } = res;
      setSubmitting(false);
      // log.trace('res:', ok, token, refreshToken);
      if (ok) {
        // ensure that any previously logged in user is logged out
        localStorage.removeItem(REACT_APP_TOKEN_NAME);
        localStorage.removeItem(REACT_APP_REFRESH_TOKEN_NAME);
        if (!onComplete) {
          log.warn('onComplete prop required but not provided');
          setStatus('showSubmittedMessage');
        } else if (!token) {
          setErrors({
            unknown: ['Failed to retrieve preregistration token']
          });
        } else {
          await onComplete(values, token);
        }
      } else if (onUserAlreadyExists) {
        // log.trace('errors[0]:', errors[0], errors[0].path, errors[0].message);
        // consider the errors that are returned and if specified, forward specific ones back to the parent component
        if (!errors || errors.length === 0) {
          setErrors(normalizeErrors([{
            message: 'no errors returned'
          }], 'unknown', true));
        } else if (errors[0].path === 'password') {
          onUserAlreadyExists('incorrect_password', values, token);
        } else if (errors[0].path === 'notVerified') {
          onUserAlreadyExists('not_verified', values, token);
        } else if (errors[0].path === 'exists_valid') {
          localStorage.setItem(REACT_APP_TOKEN_NAME, token);
          localStorage.setItem(REACT_APP_REFRESH_TOKEN_NAME, refreshToken);
          onUserAlreadyExists('exists_authenticated', values, token);
        } else {
          setErrors(normalizeErrors(errors, 'unknown', true));
        }
      } else {
        setErrors(normalizeErrors(errors, 'unknown', true));
      }
    } catch (error) {
      setSubmitting(false);
      log.trace('error:', error);
      setErrors({
        unknown: [error.message]
      });
    }
  }
});
const concatErrors = errors => {
  const list = _.concat(errors.email, errors.firstName, errors.lastName, errors.password, errors.passwordConfirm,
  // errors.termsOfUse,
  errors.unknown && "".concat(errors.unknown, ": unknown"));
  const returnList = list.filter(value => value && value !== 'deletedAt must be unique');
  if (!list.length) list[0] = 'unknown error';
  return returnList;
};

/** New Account Form is intended as a general purpose sign up page or dialog
 * <br /><br /><hr /><br />
 * <div>
 * <h4>Back-end Requirements</h4>
 * A backend graphql api endpoint with the register mutation,
 * <a rel=noopener href="https://github.com/emyw/auth-api">auth-api</a>,
 * is needed for this form to function.
 * <h4>New Account</h4>
 * The new account for includes the basic information needed to create a new user account and provides a
 * submit button for the user to create their new account when the form is complete.<br />
 * Upon clicking submit, a confirmation screen will be presented once the server responds that
 * the verification email was sent to the email address provided.<br />
 * Upon receipt of the email, the user will need to click on the verification link provided which
 * directs them to the VerifiAccountForm component to complete the account setup.
 * </div>
 */
const NewAccountForm = _ref2 => {
  let {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    status,
    touched,
    errors,
    onClose,
    onLogin,
    onTermsClick,
    onPrivacyClick,
    template,
    onComplete,
    includeHeader,
    socialNetworkUser
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", null, template === 'default' && /*#__PURE__*/React.createElement("div", null, includeHeader === true && /*#__PURE__*/React.createElement(Header, {
    color: "blue",
    attached: "top"
  }, /*#__PURE__*/React.createElement(EnjoyIcon, {
    className: "formTitleIcon"
  }), " \xA0 Create a New Account"), /*#__PURE__*/React.createElement(Header, {
    block: true,
    attached: "bottom",
    as: "h5"
  }, "Already have an account?", /*#__PURE__*/React.createElement(ButtonLink, {
    color: "blue",
    onClick: () => {
      if (onLogin) onLogin();else log.warn('onLogin prop required but not provided');
      onClose();
    }
  }, "\xA0\xA0Log in")), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.email
  }, /*#__PURE__*/React.createElement(Input, {
    name: "email",
    id: "email",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.email,
    icon: "mail",
    iconPosition: "left",
    placeholder: "Email",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.firstName
  }, /*#__PURE__*/React.createElement(Input, {
    name: "firstName",
    id: "firstName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.firstName,
    icon: "id card outline",
    iconPosition: "left",
    placeholder: "First Name",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.lastName
  }, /*#__PURE__*/React.createElement(Input, {
    name: "lastName",
    id: "lastName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.lastName,
    icon: "id card outline",
    iconPosition: "left",
    placeholder: "Last Name",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), !socialNetworkUser && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.password
  }, /*#__PURE__*/React.createElement(Input, {
    name: "password",
    id: "password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.password,
    icon: "lock",
    type: "password",
    iconPosition: "left",
    placeholder: "Password",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.passwordConfirm
  }, /*#__PURE__*/React.createElement(Input, {
    name: "passwordConfirm",
    id: "passwordConfirm",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.passwordConfirm,
    icon: "lock",
    type: "password",
    iconPosition: "left",
    placeholder: "Confirm Password",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  })))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    className: "square promotionalOptIn",
    name: "promotionalOptIn",
    id: "promotionalOptIn",
    value: values.promotionalOptIn
    // onClick={(e) => { e.preventDefault(); e.target.checked = !e.target.checked; }}
    ,
    onChange: (e, data) => {
      setFieldValue(data.id, data.checked);
    },
    onKeyDown: e => {
      if (!e.repeat && e.keyCode === 32) {
        e.target.checked = !e.target.checked;
      }
    },
    label: "I want to receive updates and special offers from Enjoy Movies Your Way."
    // {(
    //     <label>
    //         <div>I agree to receive promotional emails, special offers, and updates</div>
    //         <div>
    //             from Enjoy Movies Your Way LLC, and I agree to the
    //             <ButtonLink onClick={() => { onPrivacyClick(); }}>
    //                 &nbsp;Privacy Policy
    //             </ButtonLink>.
    //         </div>
    //     </label>
    // )}
  })), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Button, {
    className: "square",
    type: "submit",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    primary: true,
    fluid: true,
    style: {
      margin: '0px auto',
      maxWidth: '300px'
    }
  }, "CONTINUE")), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "termsAgreement"
  }, "By continuing you are agreeing to our ", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: () => {
      onTermsClick();
    }
  }, "Terms of Use"), " and ", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: () => {
      onPrivacyClick();
    }
  }, "Privacy Policy"), ".")), (touched.email && errors.email || touched.firstName && errors.firstName || touched.lastName && errors.lastName || touched.password && errors.password || touched.passwordConfirm && errors.passwordConfirm
  // || (touched.termsOfUse && errors.termsOfUse)
  || errors.unknown) && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Message, {
    size: "small",
    error: true,
    header: "Trouble with registration form...",
    list: concatErrors(errors)
  })), /*#__PURE__*/React.createElement(Modal, {
    open: status === 'showSubmittedMessage',
    closeOnDimmerClick: false,
    onClose: onClose,
    size: "mini",
    className: "enjoyModal"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(Message.Header, null, "Email was sent"), /*#__PURE__*/React.createElement("p", null, "Once received, click the provided link to verify your account.")), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: () => {
      if (onComplete) onComplete();else log.warn('onComplete prop required but not provided');
      if (onClose) onClose();
      if (onLogin) onLogin();else log.warn('onLogin prop required but not provided');
    },
    basic: true,
    color: "blue",
    fluid: true
  }, "OK")))), template === 'simple' && /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '500px',
      margin: '0px auto'
    }
  }, includeHeader && /*#__PURE__*/React.createElement(Header, {
    size: "huge",
    color: "black"
  }, "Create a New Account", /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  })), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.email
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Email",
    size: "large",
    name: "email",
    id: "email",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.email,
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.firstName
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "First Name",
    size: "large",
    name: "firstName",
    id: "firstName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.firstName,
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.firstName
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Last Name",
    size: "large",
    name: "lastName",
    id: "lastName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.lastName,
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), !socialNetworkUser && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.password
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Password",
    size: "large",
    name: "password",
    id: "password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.password,
    type: "password",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.passwordConfirm
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Confirm Password",
    size: "large",
    name: "passwordConfirm",
    id: "passwordConfirm",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.passwordConfirm,
    type: "password",
    fluid: true
  }, /*#__PURE__*/React.createElement("input", {
    "data-lpignore": true
  })))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    className: "square promotionalOptIn",
    name: "promotionalOptIn",
    id: "promotionalOptIn",
    defaultChecked: values.promotionalOptIn
    // onClick={(e) => { e.preventDefault(); e.target.checked = !e.target.checked; }}
    ,
    onChange: (e, data) => {
      setFieldValue(data.id, data.checked);
    },
    onKeyDown: e => {
      if (!e.repeat && e.keyCode === 32) {
        e.target.checked = !e.target.checked;
      }
    },
    label: "I want to receive updates and special offers from Enjoy Movies Your Way."
    // {(
    //     <label>
    //         <div>I agree to receive promotional emails, special offers, and updates</div>
    //         <div>
    //             from Enjoy Movies Your Way LLC, and I agree to the
    //             <ButtonLink onClick={() => { onPrivacyClick(); }}>
    //                 &nbsp;Privacy Policy
    //             </ButtonLink>.
    //         </div>
    //     </label>
    // )}
  })), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Button, {
    className: "square",
    type: "submit",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    primary: true,
    fluid: true,
    style: {
      margin: '0px auto',
      maxWidth: '300px'
    }
  }, "CONTINUE")), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "termsAgreement"
  }, "By continuing you are agreeing to our ", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: () => {
      onTermsClick();
    }
  }, "Terms of Use"), " and ", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: () => {
      onPrivacyClick();
    }
  }, "Privacy Policy"), ".")), (touched.email && errors.email || touched.firstName && errors.firstName || touched.lastName && errors.lastName || touched.password && errors.password || touched.passwordConfirm && errors.passwordConfirm
  // || (touched.termsOfUse && errors.termsOfUse)
  || errors.unknown) && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Message, {
    size: "small",
    error: true,
    header: "Trouble with registration form...",
    list: concatErrors(errors)
  })), /*#__PURE__*/React.createElement(Modal, {
    open: status === 'showSubmittedMessage',
    closeOnDimmerClick: false,
    onClose: onClose,
    size: "mini",
    className: "enjoyModal"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(Message.Header, null, "Email was sent"), /*#__PURE__*/React.createElement("p", null, "Once received, click the provided link to verify your account.")), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: () => {
      if (onComplete) onComplete();else log.warn('onComplete prop required but not provided');
      if (onClose) onClose();
      if (onLogin) onLogin();else log.warn('onLogin prop required but not provided');
    },
    basic: true,
    color: "blue",
    fluid: true
  }, "OK")))));
};
NewAccountForm.defaultProps = {
  user: undefined,
  socialNetworkUser: undefined,
  includeHeader: true,
  template: 'default',
  preRegistration: false,
  onClose: () => null,
  onUserAlreadyExists: undefined
};
export default NewAccountLogic(NewAccountForm);